import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "base-item",
    class: {
      layer: _vm.hasLayer
    },
    attrs: {
      "data-url": _vm.item.tActType.sH5Url
    },
    on: {
      "click": function click($event) {
        return _vm.click();
      }
    }
  }, [_c('v-image', {
    class: _defineProperty({
      radius: _vm.isBorderRadius
    }, _vm.type, true),
    attrs: {
      "src": _vm.imgSrc
    }
  }), _vm._t("icon")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };